import { render, staticRenderFns } from "./RoleSwitcher.vue?vue&type=template&id=1221e2d4&scoped=true"
import script from "./RoleSwitcher.vue?vue&type=script&lang=js"
export * from "./RoleSwitcher.vue?vue&type=script&lang=js"
import style0 from "./RoleSwitcher.vue?vue&type=style&index=0&id=1221e2d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221e2d4",
  null
  
)

export default component.exports